import React from 'react'
import { useTranslation } from 'react-i18next';
import '../css/index.css'
export const About = () => {
  const { t } = useTranslation(["home"]);

  return (
    <div>
      <section className="rSec1">
        <h1>{t("about.sec1-h1")}</h1>
        <div className="groupImg"><img src={require("../assets/aboutImg.gif")} alt="develop" /></div>
      </section>

      <section className="rSec2">
        <h1>{t("about.sec2-h1")}</h1>
        <p>{t("about.sec2-p")}</p>
      </section>



      <section className="rSec2 aSec3">
        <div className="rSec1"><div className="groupImg"><img src={require("../assets/aboutImg2.png")} alt="develop" /></div></div>
        <h1>{t("about.sec3-h1")}</h1>
        <p>{t("about.sec3-p")}</p>
      </section>
      <section className="section-3">
        <table cellSpacing="0" cellPadding="0" id="tablepress-1" className="tablepress tablepress-id-1">
          <thead>
            <tr className="row-1">
              <th className="column-1">&nbsp;</th><th className="column-2"><center><h3 style={{ fontWeight: "700" }}>STANDARD MSP&#8217;s</h3></center></th><th className="column-3"><center><h3 style={{ fontWeight: "700" }}>Strong IT</h3></center></th>
            </tr>
          </thead>
          <tbody className="row-hover">
            <tr className="row-2">
              <td className="column-1">{t("about.tr1-1")}</td><td className="column-2"><center><img src={require("../assets/standard_msp.png")} alt="img" width="35" height="0" /></center></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-3">
              <td className="column-1">{t("about.tr1-2")} </td><td className="column-2"><center><img loading="lazy" src={require("../assets/standard_msp.png")} alt="img" width="35" height="0" /></center></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-4">
              <td className="column-1">{t("about.tr1-3")}</td><td className="column-2"><center><img loading="lazy" src={require("../assets/standard_msp.png")} alt="img" width="35" height="0" /></center></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-5">
              <td className="column-1">{t("about.tr1-4")}</td><td className="column-2"><center><img loading="lazy" src={require("../assets/standard_msp.png")} alt="img" width="35" height="0" /></center></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-6">
              <td className="column-1">{t("about.tr1-5")}</td><td className="column-2"><center><img loading="lazy" src={require("../assets/standard_msp.png")} alt="img" width="35" height="0" /></center></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-7">
              <td className="column-1">{t("about.tr1-6")}</td><td className="column-2"><center><img loading="lazy" src={require("../assets/standard_msp.png")} alt="img" width="35" height="0" /></center></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-8">
              <td className="column-1">{t("about.tr1-7")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-9">
              <td className="column-1">{t("about.tr1-8")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-10">
              <td className="column-1">{t("about.tr1-9")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-11">
              <td className="column-1">{t("about.tr1-10")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-12">
              <td className="column-1">{t("about.tr1-11")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-13">
              <td className="column-1">{t("about.tr1-12")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-14">
              <td className="column-1">{t("about.tr1-13")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-15">
              <td className="column-1">{t("about.tr1-14")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-16">
              <td className="column-1">{t("about.tr1-15")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-17">
              <td className="column-1">{t("about.tr1-16")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-18">
              <td className="column-1">{t("about.tr1-17")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-19">
              <td className="column-1">{t("about.tr1-18")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-20">
              <td className="column-1">{t("about.tr1-19")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-21">
              <td className="column-1">{t("about.tr1-20")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
            <tr className="row-22">
              <td className="column-1">{t("about.tr1-21")}</td><td className="column-2"></td><td className="column-3"><center><img loading="lazy" src={require("../assets/hdit_msp.png")} alt="img" width="35" height="0" /></center></td>
            </tr>
          </tbody>
        </table>
        <div className="btns aboutBtn">
          <a href="/services" className="ourService">{t("about.btn1")}</a>
        </div>
      </section>
      <section className="sec4 section-4">
        <div className="subsec1 aSubSec1">
          <img id="clockImg" src={require("../assets/display.png")} alt="img" />
          <div>
            <h3 className="heading3">{t("about.sec4-1-h3")}</h3>
            <p className="desc">
              {t("about.sec4-1-p")}
            </p>
          </div>
        </div>
        <div className="subsec2 aSubSec2">
          <img src={require("../assets/mygreen.png")} alt="img" />
          <div>
            <h3 className="heading4">{t("about.sec4-2-h3")}</h3>
            <p className="desc">
            {t("about.sec4-2-p")}
            </p>
          </div>
        </div>
      </section>
     
      
    </div>
  )
}


